export const GET_PRODUCTS = "products/GET_PRODUCTS";